// src/context/MessageContext.js
/* eslint-disable */
import React, { createContext, useContext, useState, useCallback } from 'react';
import { Snackbar, Alert } from '@mui/material';

const MessageContext = createContext();

export const MessageProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const showMessage = useCallback((message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  }, []);

  const handleClose = () => setSnackbar((prev) => ({ ...prev, open: false }));

  return (
    <MessageContext.Provider value={{ showMessage }}>
      {children}

      {/* ✅ Snackbar ที่ใช้ได้ทุกหน้า พร้อมฟอนต์ Noto Sans Thai */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          severity={snackbar.severity}
          onClose={handleClose}
          variant="filled"
          sx={{
            width: '100%',
            borderRadius: 2,
            fontFamily: '"Noto Sans Thai", sans-serif',
            fontSize: '0.95rem',
            letterSpacing: '0.02em',
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </MessageContext.Provider>
  );
};

export const useMessage = () => useContext(MessageContext);
